<template>
  <el-container>
    <el-header height="20px">
      <el-popover
          placement="top-start"
          trigger="click">
          <el-table :data="hedgeAccountEnum">
            <el-table-column width="200" property="key" label="对冲账号"></el-table-column>
            <el-table-column width="500" property="label" label="说明"></el-table-column>
          </el-table>
        <el-button slot="reference" size="small">对冲账号说明</el-button>
      </el-popover>

      <el-popover
          placement="top-start"
          trigger="click">
        <el-table :data="ExternalOrderStatusEnum">
          <el-table-column width="200" property="key" label="外部委托状态"></el-table-column>
          <el-table-column width="400" property="label" label="说明"></el-table-column>
        </el-table>
        <el-button slot="reference" size="small">外部委托状态说明</el-button>
      </el-popover>

      <el-popover
          placement="top-start"
          trigger="click">
        <el-table :data="HedgeSourceRecordStatusEnum">
          <el-table-column width="300" property="key" label="原始记录状态"></el-table-column>
          <el-table-column width="600" property="label" label="说明"></el-table-column>
        </el-table>
        <el-button slot="reference" size="small">原始记录状态说明</el-button>
      </el-popover>

      <el-popover
          placement="top-start"
          trigger="click">
        <el-table :data="RiskHedgeFailTypeEnum">
          <el-table-column width="350" property="key" label="外部对冲状态"></el-table-column>
          <el-table-column width="350" property="label" label="说明"></el-table-column>
        </el-table>
        <el-button slot="reference" size="small">外部对冲失败说明</el-button>
      </el-popover>

      <el-popover
          placement="top-start"
          trigger="click">
        <el-table :data="TryHedgeResultEnum">
          <el-table-column width="400" property="key" label="尝试对冲结果"></el-table-column>
          <el-table-column width="500" property="label" label="说明"></el-table-column>
        </el-table>
        <el-button slot="reference" size="small">尝试对冲结果说明</el-button>
      </el-popover>
    </el-header>
    <el-main>
      <el-tabs v-model="activeName" v-if="rightsContains('NEW_HEDGE_MANAGE')">
        <el-tab-pane label="查询周期策略统计" name="statics">
          <div>
            <el-card>
              <div class="block">
                <el-form :inline="true">
                  <el-form-item label="日期">
                    <el-date-picker
                        v-model="dateRange"
                        value-format="timestamp"
                        format="yyyy-MM-dd HH:mm:ss"
                        type="datetimerange"
                        :picker-options="pickerOptions"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        align="right"
                        clearable
                        editable
                    ></el-date-picker>
                  </el-form-item>
                  <el-form-item label="对冲产品:">
                    <el-select v-model="hedgeProductType" placeholder="请选择对冲产品">
                      <el-option v-for="item in hedgeProductTypeOptions" :key="item.key" :label="item.label" :value="item.key"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="对冲目标类型:">
                    <el-select v-model="hedgeTargetType" placeholder="请选择对冲目标类型">
                      <el-option v-for="item in hedgeTargetTypeEnum" :key="item.key" :label="item.label" :value="item.key"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="对冲目标值:">
                    <el-input v-model="hedgeTargetValue" placeholder="请输入对冲目标类值"></el-input>
                  </el-form-item>
                  <el-form-item label="交易对:">
                    <el-input v-model="pair" placeholder="请输入交易对"></el-input>
                  </el-form-item>
<!--                  <el-form-item label="对冲场所:">-->
<!--                    <el-select v-model="account" placeholder="请选择对冲场所">-->
<!--                      <el-option v-for="item in hedgeAccountEnum" :key="item.key" :label="item.key" :value="item.key"></el-option>-->
<!--                    </el-select>-->
<!--                  </el-form-item>-->
                  <el-form-item label="结算开关：">
                    <el-switch
                        v-model="settlement"
                        active-text="开"
                        inactive-text="关">
                    </el-switch>
                  </el-form-item>
                  <el-form-item>
                    <el-button type="primary" icon="el-icon-search" :plain="true" @click="queryStrategy">查询</el-button>
                  </el-form-item>
                </el-form>

                <div class="top" v-if="isShow">
                  <div style="text-align:right">
                    <el-select v-model="filter.targetExchange" placeholder="对冲账号过滤" size="small">
                      <el-option v-for="item in hedgeAccountEnum" :key="item.key" :label="item.key" :value="item.key" size="small"></el-option>
                    </el-select>
                    <el-select v-model="filter.strategyStatus" placeholder="策略状态过滤" size="small">
                      <el-option v-for="item in strategyStatusOptions" :key="item.key" :label="item.key"  size="small" :value="item.key"></el-option>
                    </el-select>
                    <el-button type="primary" size="small" @click="clearFilter">清除过滤</el-button>
                  </div>
                  <el-table :data="tableData" style="width: 100%" max-height="1000">
                    <el-table-column fixed prop="strategy" label="策略" sortable width="150"></el-table-column>
                    <el-table-column label="交易平台" align="center">
                      <el-table-column prop="exchangeBidQuantity" label="成交数量（买）" width="80" :sortable="true" :sort-method="(a, b) => sortHandler(a, b, 'exchangeBidQuantity')"></el-table-column>
                      <el-table-column prop="exchangeAskQuantity" label="成交数量（卖）" width="80" :sortable="true" :sort-method="(a, b) => sortHandler(a, b, 'exchangeAskQuantity')"></el-table-column>
                      <el-table-column prop="exchangeBidAvgPrice" label="成交均价（买）" width="80" :sortable="true" :sort-method="(a, b) => sortHandler(a, b, 'exchangeBidAvgPrice')"></el-table-column>
                      <el-table-column prop="exchangeAskAvgPrice" label="成交均价（卖）" width="80" :sortable="true" :sort-method="(a, b) => sortHandler(a, b, 'exchangeAskAvgPrice')"></el-table-column>
                      <el-table-column prop="exchangeFixedBenefit" label="固定盈亏" width="80" :sortable="true" :sort-method="(a, b) => sortHandler(a, b, 'exchangeFixedBenefit')"></el-table-column>
                      <el-table-column prop="exchangeFloatBenefit" label="浮动盈亏" width="80" :sortable="true" :sort-method="(a, b) => sortHandler(a, b, 'exchangeFloatBenefit')"></el-table-column>
                    </el-table-column>
                    <el-table-column label="程序成功对冲" align="center">
                      <el-table-column prop="autoHedgeBidQuantity" label="成交数量（买）" width="80" :sortable="true" :sort-method="(a, b) => sortHandler(a, b, 'autoHedgeBidQuantity')"></el-table-column>
                      <el-table-column prop="autoHedgeAskQuantity" label="成交数量（卖）" width="80" :sortable="true" :sort-method="(a, b) => sortHandler(a, b, 'autoHedgeAskQuantity')"></el-table-column>
                      <el-table-column prop="autoHedgeBidAvgPrice" label="成交均价（买）" width="80" :sortable="true" :sort-method="(a, b) => sortHandler(a, b, 'autoHedgeBidAvgPrice')"></el-table-column>
                      <el-table-column prop="autoHedgeAskAvgPrice" label="成交均价（卖）" width="80" :sortable="true" :sort-method="(a, b) => sortHandler(a, b, 'autoHedgeAskAvgPrice')"></el-table-column>
                      <el-table-column prop="autoHedgeFixedBenefit" label="买卖盈亏" width="80" :sortable="true" :sort-method="(a, b) => sortHandler(a, b, 'autoHedgeFixedBenefit')"></el-table-column>
                    </el-table-column>
                    <el-table-column  label="人工成功对冲" align="center">
                      <el-table-column prop="manualHedgeBidQuantity" label="成交数量（买）" width="80" :sortable="true" :sort-method="(a, b) => sortHandler(a, b, 'manualHedgeBidQuantity')"></el-table-column>
                      <el-table-column prop="manualHedgeAskQuantity" label="成交数量（卖）" width="80" :sortable="true" :sort-method="(a, b) => sortHandler(a, b, 'manualHedgeAskQuantity')"></el-table-column>
                      <el-table-column prop="manualHedgeBidAvgPrice" label="成交均价（买）" width="80" :sortable="true" :sort-method="(a, b) => sortHandler(a, b, 'manualHedgeBidAvgPrice')"></el-table-column>
                      <el-table-column prop="manualHedgeAskAvgPrice" label="成交均价（卖）" width="80" :sortable="true" :sort-method="(a, b) => sortHandler(a, b, 'manualHedgeAskAvgPrice')"></el-table-column>
                      <el-table-column prop="manualHedgeFixedBenefit" label="买卖盈亏" width="80" :sortable="true" :sort-method="(a, b) => sortHandler(a, b, 'manualHedgeFixedBenefit')"></el-table-column>
                    </el-table-column>
                    <el-table-column label="需对冲" align="center">
                      <el-table-column label="对冲量" width="80" :sortable="true" :sort-method="(a, b) => sortHandler(a, b, 'quantityNotHedged')">
                        <template slot-scope="scope">
                          <span style="color:red; font-weight: bolder" v-if="scope.row.quantityNotHedged.replaceAll(',', '') > 0">{{ scope.row.quantityNotHedged }}</span>
                          <span style="color:green; font-weight: bolder" v-else>{{ scope.row.quantityNotHedged }}</span>
                        </template>
                      </el-table-column>
                      <!--                  <el-table-column prop="suggestedHedgePrice" label="建议对冲价" sortable width="80"></el-table-column>-->
                      <el-table-column label="对冲额U" width="80" :sortable="true" :sort-method="(a, b) => sortHandler(a, b, 'notHedgeUsdtAmt')">
                        <template slot-scope="scope">
                          <span style="color:red; font-weight: bolder" v-if="scope.row.notHedgeUsdtAmt.replaceAll(',', '') > 10000">{{ scope.row.notHedgeUsdtAmt }}</span>
                          <span style="color:green; font-weight: bolder" v-else>{{ scope.row.notHedgeUsdtAmt }}</span>
                        </template>
                      </el-table-column>
                    </el-table-column>
                    <el-table-column label="盈利详情" align="center">
                      <el-table-column prop="floatBenefitNotHedged" label="需要对冲浮动盈亏" width="80" :sortable="true" :sort-method="(a, b) => sortHandler(a, b, 'floatBenefitNotHedged')"></el-table-column>
                      <el-table-column prop="fixedBenefitTotal" label="总固定盈亏" width="80" :sortable="true" :sort-method="(a, b) => sortHandler(a, b, 'fixedBenefitTotal')"></el-table-column>
                      <el-table-column prop="costPrice" label="成本价" width="80" :sortable="true" :sort-method="(a, b) => sortHandler(a, b, 'costPrice')"></el-table-column>
                    </el-table-column>
                    <el-table-column prop="currentPrice" label="现价" sortable width="80"></el-table-column>
                    <el-table-column prop="hedgeAccount" label="对冲账号" sortable width="80"></el-table-column>
                    <el-table-column prop="strategyStatus" label="策略状态" sortable width="80"></el-table-column>
                    <el-table-column prop="currencyPairLevel" label="币对等级" sortable width="80"></el-table-column>
                    <el-table-column prop="financeDifference" label="财务差额" sortable width="80"></el-table-column>
                    <el-table-column prop="lastConfirmTime" label="上一次结算时间" width="90"></el-table-column>
                    <el-table-column prop="" label="操作" width="110">
                      <template slot-scope="scope">
                        <el-button @click="closeHedgeCycleRecord(scope.row)" type="primary" size="small">盈亏结算</el-button>
                      </template>
                    </el-table-column>

                  </el-table>
                  <div style="text-align:right">
                    <el-button type="success" plain @click="exportExcel()">导出excel</el-button>
                  </div>
                </div>
              </div>
            </el-card>
          </div>
        </el-tab-pane>
        <el-tab-pane label="查询对冲原始记录" name="srcRecords" v-if="rightsContains('NEW_HEDGE_SRC_RECORDS')">
          <resource-records></resource-records>
        </el-tab-pane>
        <el-tab-pane label="查询合并对冲记录" name="batchRecords" v-if="rightsContains('NEW_HEDGE_BATCH_RECORDS')">
          <batch-records></batch-records>
        </el-tab-pane>
        <el-tab-pane label="添加手动对冲记录" name="manualRecords" v-if="rightsContains('NEW_HEDGE_ADD_MANUAL_RECORD')">
          <manual-records></manual-records>
        </el-tab-pane>
        <el-tab-pane label="对冲策略" name="strategy" v-if="rightsContains('NEW_HEDGE_STRATEGY')">
          <hedge-strategy></hedge-strategy>
        </el-tab-pane>
        <el-tab-pane label="对冲周期盈亏统计" name="benefit" v-if="rightsContains('NEW_HEDGE_STRATEGY')">
          <strategy-benefit></strategy-benefit>
        </el-tab-pane>
        <el-tab-pane label="财务差额统计" name="reconciliation" v-if="rightsContains('NEW_HEDGE_STRATEGY')">
          <reconciliation-balance></reconciliation-balance>
        </el-tab-pane>
        <el-tab-pane label="需对冲快照" name="notHedgeMonitor" v-if="rightsContains('NEW_HEDGE_STRATEGY')">
          <not-hedged-monitor></not-hedged-monitor>
        </el-tab-pane>
        <el-tab-pane label="折线图" name="chart">
          <hedging-chart />
        </el-tab-pane>
      </el-tabs>
    </el-main>
  </el-container>
</template>

<script>
import './store'
import '@/entries/Machine/cache'
import {mapActions, mapState} from "vuex";
import utils from "./utils";
import {RIGHTS_TYPE} from "@/common/constant";
import HedgeStrategy from './HedgeStrategy';
import ResourceRecords from "./ResourceRecords";
import BatchRecords from "./BatchRecords";
import ManualRecords from "./ManualRecords";
import HistoryBalance from "./HistoryBalance";
import StrategyBenefit from './StrategyBenefit'
import ReconciliationBalance from "@/entries/HedgeCenter/MarketSheet/ReconciliationBalance";
import NotHedgedMonitor from "@/entries/HedgeCenter/MarketSheet/NotHedgedMonitor";
import HedgingChart from './HedgingChart'

const strategyStatusOp = [{key:'', label:''}, {key:'OPEN', label:"OPEN"}, {key:'CLOSE', label:'CLOSE'},]
const hedgeTargetTypeSPOTOptions = [
  {key:'', label:''},
  {key:'SPOT_PAIR_COMMON', label:'现货匹配交易对'},
  {key:'SPOT_PAIR_API', label:'现货只匹配交易对的API的部分，优先级SPOT'},
  {key:'SPOT_USER_ID', label:'用户ID'},
  {key:'STRATEGY_NOT_EXISTS', label:'不存在的策略'},
]
const hedgeTargetTypeSUPER_CONTRACTOptions = [
  {key:'', label:''},
  {key:'SC_PAIR', label:'超级合约的交易对'},
  {key:'SC_USER_ID', label:'超级合约的交易对用户ID'},
  {key:'SPOT_USER_ID', label:'用户ID'},
  {key:'STRATEGY_NOT_EXISTS', label:'不存在的策略'},
]
const hedgeTargetTypeOptions = []
const columns=[
  {title:'策略',key:'strategy'},
  {title:'平台买方成交数量',key:'exchangeBidQuantity'},
  {title:'平台卖方成交数量',key:'exchangeAskQuantity'},
  {title:'平台买方成交均价',key:'exchangeBidAvgPrice'},
  {title:'平台卖方成交均价',key:'exchangeAskAvgPrice'},
  {title:'平台固定盈亏',key:'exchangeFixedBenefit'},
  {title:'平台浮动盈亏',key:'exchangeFloatBenefit'},
  {title:'程序成功对冲买方成交数量',key:'autoHedgeBidQuantity'},
  {title:'程序成功对冲卖方成交数量',key:'autoHedgeAskQuantity'},
  {title:'程序成功对冲买方成交均价',key:'autoHedgeBidAvgPrice'},
  {title:'程序成功对冲卖方成交均价',key:'autoHedgeAskAvgPrice'},
  {title:'程序成功对冲买卖盈亏',key:'autoHedgeFixedBenefit'},
  {title:'人工成功对冲买方成交数量',key:'manualHedgeBidQuantity'},
  {title:'人工成功对冲卖方成交数量',key:'manualHedgeAskQuantity'},
  {title:'人工成功对冲买方成交均价',key:'manualHedgeBidAvgPrice'},
  {title:'人工成功对冲卖方成交均价',key:'manualHedgeAskAvgPrice'},
  {title:'人工成功对冲买卖盈亏',key:'manualHedgeFixedBenefit'},
  {title:'需对冲数量',key:'quantityNotHedged'},
  {title:'需对冲代币价值(USDT)',key:'notHedgeUsdtAmt'},
  {title:'需对冲浮动盈亏',key:'floatBenefitNotHedged'},
  {title:'总固定盈亏',key:'fixedBenefitTotal'},
  {title:'成本价',key:'costPrice'},
  {title:'现价',key:'currentPrice'},
  {title:'财务差额',key:'financeDifference'},
  {title:'上一次结算时间',key:'lastConfirmTime'},
]

export default {
  components: {
    ReconciliationBalance, NotHedgedMonitor,
    ManualRecords, BatchRecords, ResourceRecords, HedgeStrategy, HistoryBalance, StrategyBenefit, HedgingChart},
  comments:{'HedgeStrategy':HedgeStrategy, 'ResourceRecords':ResourceRecords, 'BatchRecords':BatchRecords, 'ManualRecords':ManualRecords, 'StrategyBenefit':StrategyBenefit, 'ReconciliationBalance':ReconciliationBalance, 'NotHedgedMonitor':NotHedgedMonitor},
  data() {
    return {
      isShow:false,
      settlement: false,
      tableData:[],
      tableDataBak:[],
      account:[],
      userId:'',
      dateRange: [],
      pair:'',
      hedgeProductType:'',
      hedgeTargetType:'',
      hedgeTargetValue:'',

      productType:'',
      targetType:'',
      targetValue:'',
      filter:{
        targetExchange:'',
        strategyStatus:''
      },
      strategyStatusOptions:strategyStatusOp,
      activeName:'statics',
      hedgeTargetTypeEnum:'',
      hedgeTargetTypeEnum_SPOT:hedgeTargetTypeSPOTOptions,
      hedgeTargetTypeEnum_SUPER_CONTRACT:hedgeTargetTypeSUPER_CONTRACTOptions,
      columns:columns,
      dataInfo:{
        "exchangeBidQuantity":'exchangeBidQuantity',
        "exchangeAskQuantity":'exchangeAskQuantity',
        "exchangeBidAvgPrice":'exchangeBidAvgPrice',
        "exchangeAskAvgPrice":'exchangeAskAvgPrice',
        "exchangeFixedBenefit":'exchangeFixedBenefit',
        "exchangeFloatBenefit":'exchangeFloatBenefit',
        "autoHedgeBidQuantity":'autoHedgeBidQuantity',
        "autoHedgeAskQuantity":'autoHedgeAskQuantity',
        "autoHedgeBidAvgPrice":'autoHedgeBidAvgPrice',
        "autoHedgeAskAvgPrice":'autoHedgeAskAvgPrice',
        "autoHedgeFixedBenefit":'autoHedgeFixedBenefit',
        "manualHedgeBidQuantity":'manualHedgeBidQuantity',
        "manualHedgeAskQuantity":'manualHedgeAskQuantity',
        "manualHedgeBidAvgPrice":'manualHedgeBidAvgPrice',
        "manualHedgeAskAvgPrice":'manualHedgeAskAvgPrice',
        "manualHedgeFixedBenefit":'manualHedgeFixedBenefit',
        "quantityNotHedged":'quantityNotHedged',
        "notHedgeUsdtAmt":'notHedgeUsdtAmt',
        "floatBenefitNotHedged":'floatBenefitNotHedged',
        "fixedBenefitTotal":'fixedBenefitTotal',
      }
    }
  },
  methods: {
    ...mapActions('newHedgeStore', ['getHedgeAccountEnum']),
    exportExcel(){
      let startTime = utils.getLocalTime(this.dateRange[0])
      let endTime = utils.getLocalTime(this.dateRange[1])
      let title = '策略统计报表' + startTime + '-' + endTime
      utils.export2Excel(this.columns, this.tableData, title)
    },
    rightsContains(r) {
      let rights = this.userRights.split(",") || [];
      return rights.indexOf(RIGHTS_TYPE[r]) !== -1;
    },
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0 || columnIndex === 3 || columnIndex === 4 || columnIndex === 7 || columnIndex === 10) {
        if (rowIndex % 2 === 0) {
          return {rowspan: 2, colspan: 1};
        } else {
          return {rowspan: 0, colspan: 0};
        }
      }
    },
    deepCopy(source) {
      let sourceCopy = source instanceof Array ? [] : {};
      for (let item in source) {
        sourceCopy[item] = typeof source[item] === 'object' ? this.deepCopy(source[item]) : source[item];
      }
      return sourceCopy;
    },
    queryStrategy(){
      if (this.dateRange.length !== 2 || String(this.dateRange[1]).split(",").length > 1){
        this.$message({showClose: true, message: '请选择日期', type: 'error'})
        return
      }
      if (new Date(this.dateRange[0]).getTime() > new Date().getTime()){
        this.$message({showClose: true, message: '时间选择错误，起止时间不合理', type: 'error'});
        return
      }
      utils.queryStrategyData(this.params).then((response)=>{
        this.isShow = true
        this.tableDataBak = response.data.filter((item)=>{
          item["costPrice"] = ""
          if (item["quantityNotHedged"] !== 0){
            item["costPrice"] = item["currentPrice"] + (item["fixedBenefitTotal"] + item["floatBenefitNotHedged"]) / item["quantityNotHedged"]
          }
          for (let key in item){
            if (this.dataInfo.hasOwnProperty(key)){
              item[key] = this.convert(item[key])
            }
            if (key === 'strategyStatus'){
              if ( item[key] === '1' ){
                item[key] = "OPEN"
              }
              else if (item[key] === '0'){
                item[key] = "CLOSE"
              }
            }
          }
          this.$set(item, 'lastConfirmTime', utils.getLocalTime(item.confirmTime))
          return item
        })
        this.tableData = this.deepCopy(this.tableDataBak)
      })
    },

    convert(val){
      return val.toString();
    },

    clearFilter(){
      this.filter.strategyStatus = ''
      this.filter.targetExchange = ''
    },

    tableDataFilter(account, status){
      if (account === '' && status === ''){
        this.tableData = this.deepCopy(this.tableDataBak)
        return
      }
      let result = []
      for (let i in this.tableDataBak){
        let item = this.tableDataBak[i]
        let accounts = item.hedgeAccount.split(",")

        if (status === ''){
          if (accounts.indexOf(account) > -1){
            result.push(item)
          }
        }
        if (account === ''){
          if (item.strategyStatus === status){
            result.push(item)
          }
        }
        if (status === item.strategyStatus && accounts.indexOf(account) > -1){
          result.push(item)
        }
      }
      this.tableData = result
    },

    updateDateRange( data ) {
      let confirmTime = data.confirmTime + 1
      this.dateRange[0] = confirmTime
      let current = (new Date()).getTime();
      this.dateRange[1] = current
      this.$set(this.dateRange, '1', [confirmTime, current]);
    },

    closeHedgeCycleRecord(data) {
      this.$confirm('此操作将结算对冲周期盈亏, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true
      }).then(() => {
        let strategySplit = data.strategy.split(":")
        data.hedgeProductType = strategySplit[0]
        data.hedgeTargetType = strategySplit[1]
        data.hedgeTargetValue = strategySplit[2]
        data.pair = '1'
        data.suggestedHedgePrice = ''
        if (data.lastConfirmTime === undefined) {
          data.startTime = new Date(this.dateRange[0]).getTime()
        } else {
          data.startTime = new Date(data.lastConfirmTime).getTime() + 1000;
        }

        data.endTime = new Date(this.dateRange[1]).getTime()
        utils.addHedgeDataSnapshot(data).then((response)=>{
          if (response.data === true){
            this.$message.success('结算成功');
            this.queryStrategy()
          }else{
            this.$message.error('结算失败')
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },

    localStringExchange(val, field){
      return parseFloat(val[field].replaceAll(",", ""))
    },

    sortHandler(a, b, field){
      return this.localStringExchange(a, field) - this.localStringExchange(b, field)
    }

  },
  computed: {
    ...mapState('newHedgeStore', ['hedgeAccountEnum', 'hedgeProductTypeOptions', 'pickerOptions',
      'ExternalOrderStatusEnum', 'HedgeSourceRecordStatusEnum', 'RiskHedgeFailTypeEnum', 'TryHedgeResultEnum']),
    params() {
      return {
        startTime:new Date(this.dateRange[0]).getTime(),
        endTime:new Date(this.dateRange[1]).getTime(),
        userId: this.userId,
        hedgeProductType:this.hedgeProductType,
        hedgeTargetType:this.hedgeTargetType,
        hedgeTargetValue:this.hedgeTargetValue,
        pair:this.pair,
        settlement: this.settlement
      };
    },
    ...mapState(["userInfo", "userRights"])
  },
  watch:{
    hedgeProductType(val){
      if (val === "SPOT"){
        this.hedgeTargetTypeEnum = this.hedgeTargetTypeEnum_SPOT
      }else{
        this.hedgeTargetTypeEnum = this.hedgeTargetTypeEnum_SUPER_CONTRACT
      }
    },
    filter:{
      handler(val){
        this.tableDataFilter(val.targetExchange, val.strategyStatus)
      },
      deep:true
    }
  },
  created() {
    this.hedgeProductType = this.hedgeProductTypeOptions[0].key;
    this.productType = this.hedgeProductTypeOptions[0].key;
    if(this.rightsContains('NEW_HEDGE_MANAGE')){
      this.activeName = 'statics';
    }else if(this.rightsContains('NEW_HEDGE_SRC_RECORDS')){
      this.activeName = 'srcRecords';
    }else if(this.rightsContains('NEW_HEDGE_BATCH_RECORDS')){
      this.activeName = 'batchRecords';
    } else if(this.rightsContains('NEW_HEDGE_ADD_MANUAL_RECORD')){
      this.activeName = 'manualRecords'
    }else if(this.rightsContains('NEW_HEDGE_STRATEGY')){
      this.activeName = 'strategy'
    }
    this.getHedgeAccountEnum()
  }
}
</script>
<style>
.block{
  background-color: white;
  margin: 10px 15px 10px 15px;
  padding: 10px 5px 10px 5px;
  height: auto;
}
.item{
  margin: 20px 0 20px 0;
}
body .el-table th.gutter {
  display: table-cell !important;
}
body .el-table colgroup.gutter {
  display: table-cell !important;
}
</style>
